import PortfolioTable from './PortfolioTable';

export default PortfolioTable;
